import React from 'react';

/**
 * Affiliate disclosure.
 *
 * CJ's terms and advertising rules in the US, UK and EU require a disclosure on
 * every page that carries an affiliate link — not merely on the link itself.
 * BookingOptions discloses inside its dropdown, which a visitor who clicks the
 * primary button never opens, so any page that mounts booking buttons needs
 * this alongside them.
 *
 * Deliberately quiet: it has to be readable, not prominent.
 */
const AffiliateDisclosure = ({ className = '' }) => (
  <p className={`text-xs text-neutral-400 leading-relaxed ${className}`}>
    Some booking links on this page are affiliate links. We may earn a commission
    from bookings made through them, at no extra cost to you.
  </p>
);

export default AffiliateDisclosure;
